import ApiService from '../../services/ApiService';
import { SUCCESS_STATUS } from '../../constants/Config';
import { AUTH_USER_LOGIN, AUTH_USER_SIGNIN_FROM_STORAGE, AUTH_USER_LOGOUT } from '../types/AuthType';

export const userLogin = (data) => {
    return async (dispatch) => {
        const result = await ApiService.unAuthPostData(`login`, data);
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: AUTH_USER_LOGIN,
                payload: result.data,
                error: false
            })
        } else {
            return dispatch({
                type: AUTH_USER_LOGIN,
                error: true,
                msg: result.msg,
                details: result.details,
                status:result?.status
            })
        }
    }
}

export const signInUserFromStorage = (userData, token, userPermissions) => {
    return async (dispatch) => {
        return dispatch({
            type: AUTH_USER_SIGNIN_FROM_STORAGE,
            userInfo: {
                userData: JSON.parse(userData),
                token,
                userPermissions: JSON.parse(userPermissions)
            }
        });
    }
};

export const userLogout = () => {
    return dispatch => {
        dispatch({
            type: AUTH_USER_LOGOUT
        });
    }
};

export const clearLocalStorageAndLogout = async(logOutdata={}) => {
    try {
        const result = await ApiService.postData(`logoutMagma`, logOutdata);
        if (result.status === SUCCESS_STATUS) {
            localStorage.removeItem('_token');
            localStorage.clear()
            userLogout();
            window.location.reload();
            return {
                status: true
            };
        }        
        return {
            status: false
        };

    } catch (error) {
        return {
            status: false,
            message: error
        }
    }
}